import { render, staticRenderFns } from "./searchForm.vue?vue&type=template&id=2906dad5"
import script from "./searchForm.vue?vue&type=script&lang=js"
export * from "./searchForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports